import * as React from "react";

export interface TextToSpeechOnboardingState {
    hasOnboardingBeenViewed: boolean;
    initiateOnboarding: () => void;
}

/**
 * The default state of the text-to-speech onboarding state.
 */
const defaultState: TextToSpeechOnboardingState = Object.freeze({
    hasOnboardingBeenViewed: true,
    initiateOnboarding: () => {},
});

/**
 * A React context that provides access to the text-to-speech onboarding state.
 *
 * Please do not use this directly. Instead use the
 * TextToSpeechOnboardingProvider and useTextToSpeechOnboarding hook.
 */
export const TextToSpeechOnboardingContext: React.Context<TextToSpeechOnboardingState> =
    React.createContext(defaultState);
TextToSpeechOnboardingContext.displayName = "TextToSpeechOnboardingContext";
